<template>
    <div>
        <template v-if="paymentUnderProcess">
            <payment-under-process :product="this.product"></payment-under-process>
        </template>
        <div v-else-if="!hasPendingSubscriptions && !hasPendingRenewalSubscriptions">
            <div class="card-header py-3">
                {{ lang.app.subscription.first_product_subscription.title }}
                <br/>
                <small style="font-size: 0.9rem;">{{ lang.app.subscription.first_product_subscription.sub_title }}
                </small>
            </div>
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-7 col-xl-6 col-xxl-5 d-flex flex-column mt-5 mt-md-0">
                        <ul class="price mb-2 list-group flex-fill">
                            <li class="header list-group-item" style="background-color: #faf8f8; color: #333;">
                                {{ lang.app.subscription[subscriptionModules[product].title] }}
                            </li>
                            <li class="list-group-item"
                                v-for="module in form.subscription_modules">
                                <template v-if="(subscribedModules && subscribedModules[module.id]) ">
                                    <span class="fa mr-2 mx-md-3"
                                          :class="{ 'fa-check' : (subscribedModules && subscribedModules[module.id])}">
                                    </span>
                                    <span class="sub-prod-name">{{ module.id.replace(/^\w/, c => c.toUpperCase()) }} </span>
                                    <template v-if="subscribedModules[module.id].to_date">
                                        <span class="float-right pr-md-3">
                                            {{ module.is_unsubscribed ? lang.app.subscription.ends_on : lang.app.subscription.renew_on}}
                                            {{ subscribedModules[module.id].to_date | formatDate('DD/MM/YYYY') }}
                                        </span>
                                    </template>
                                    <template v-if="module.can_unsubscribe">
                                        <a class="btn-subscription small font-weight-bold ml-1"
                                           @click="toggleSubscription(module)">
                                            {{ (module.is_unsubscribed) ? lang.app.subscription.subscribe : lang.app.subscription.unsubscribe }}
                                        </a>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="text-center py-4">
                                        <h3 class="py-3">
                                            € {{ (module.amount) | floatVal }}
                                            <sub>
                                                <small v-if="user.role == 'advisor'">/ jaar</small>
                                                <small v-else>/ 6mnd</small>
                                            </sub>
                                        </h3>
                                        <h4 class="py-3" v-if="user.pre_registered_discount > 0">
                                            i.p.v. € {{ module.full_amount | floatVal }} <sub>
                                        </sub>
                                        </h4>
                                        <small v-if="user.role == 'advisor'">
                                            <br/>
                                            <b>Pakketten voor organisaties</b> <br/>via offerte op maat via
                                            <a :href="'mailto:info@farmdesk.eu'" style="color: #333;">
                                                <u>{{'info@farmdesk.eu'}}</u>
                                            </a>
                                        </small>
                                    </div>
                                </template>
                            </li>
                        </ul>
                        <div class="text-center mt-2">
                            <div>
                                <template v-if="paymentEnabled">
                                    <button-loader
                                            v-if="!hasActiveSubscriptions"
                                            :isLoading="subscribeCapripediaLoader"
                                            :disabled="subscribeCapripediaLoader"
                                            :classes="'btn btn-primary btn-block px-md-4 mt-3 background-' + this.product"
                                            @click="submit"
                                    > {{ lang.app.subscription.submit }}
                                    </button-loader>
                                    <a v-else :class="'btn btn-primary btn-block background-' + this.product" :href="'/nl/' + product">
                                        Ga naar {{ lang.app.subscription[subscriptionModules[product].title] }}
                                    </a>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row py-4 justify-content-center" style="margin-top: 80px;">
                    <div class="col-md-8 col-lg-7 col-xl-6 col-xxl-5 d-flex flex-column mt-5 mt-md-0 text-center p-0">
                        <small>
                            <span v-html="lang.app.subscription.first_product_subscription.bottom_text"></span>&nbsp;
                        </small>
                        <small>
                            <span v-html="lang.app.subscription.first_product_subscription.terms_condition_text"></span>&nbsp;
                        </small>
                        <small>
                            <span v-html="lang.app.subscription.first_product_subscription.ask_any_question_text"></span>&nbsp;
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="card-body">
                <div class="row justify-content-center px-3">
                    <payment-pending-screen :payment-url="paymentUrl" :user="user" :product="product"/>
                </div>
            </div>
        </div>
        <confirmation-modal
                :message="this.confirmationMessage"
                :is-open="isOpen"
                @result="confirmationResult"
                :product="this.product"
        ></confirmation-modal>
    </div>
</template>
<script>
    import PaymentPendingScreen from "./tool/PaymentPendingScreen";
    const moment = require('moment');

    export default {

        props: ['user', 'subscriptionModules', 'paymentEnabled', 'paymentUrl', 'product', 'paymentUnderProcess'],

        components: {
            PaymentPendingScreen
        },

        data() {
            return {
                subscribeCapripediaLoader: false,
                errorMessages: [],
                form: this.getForm(),
                hasPendingSubscriptions: this.getHasPendingSubscriptions(),
                hasActiveSubscriptions: this.getHasActiveSubscriptions(),
                hasPendingRenewalSubscriptions: this.getHasPendingRenewalSubscriptions(),
                userPaymentUrl: this.paymentUrl,
                themeColor: this.getThemeColor(),
                isOpen: false,
                currentModuleId: null,
                confirmationMessage: null,
                confirmationType: null
            }
        },

        methods: {

            getHasPendingSubscriptions() {
                // TODO boolean
                return _.some(this.user.subscriptionModules, {'is_pending': 1, 'is_active': 0, 'module' : this.product}) ||
                    _.some(this.user.subscriptionModules, {'is_pending': true, 'is_active': false, 'module' : this.product});
            },

            getHasActiveSubscriptions() {
                return _.some(this.user.subscriptionModules, {'is_active': 1, 'module' : this.product}) ||
                    _.some(this.user.subscriptionModules, {'is_active': true, 'module' : this.product})
            },

            getHasPendingRenewalSubscriptions() {
                return _.some(this.user.pendingRenewalSubscriptions, {'is_pending': 1, 'is_active': 0, 'is_renew': 1, 'module' : this.product}) ||
                    _.some(this.user.pendingRenewalSubscriptions, {'is_pending': true, 'is_active': false, 'is_renew': true, 'module' : this.product});
            },

            submit() {
                let form = this.getForm();
                this.subscribeCapripediaLoader = true;
                api.subscription
                    .postCreateSubscriptionAction(form)
                    .then(response => {
                        this.messageStatus = 'success';
                        this.subscribeCapripediaLoader = false;
                        window.location.reload();
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 422) {
                            this.messageText = lang.validation.error_message;
                            this.messageStatus = "error";
                            if (error.response && error.response.data) {
                                this.formError = error.response.data;
                            }
                        }
                        this.subscribeCapripediaLoader = false;
                        window.location.reload();
                    });
            },

            getForm() {

                let form = {
                    subscription_modules: [],
                    type: this.product,
                };

                let totalAmount = 0;
                _.forEach(this.subscriptionModules[this.product].products, (product) => {
//                    let amount = parseFloat((this.user.farmer &&
//                        this.user.farmer.is_professional) ?
//                        product.farmer_price : product.non_farmer_price);

                    let amount = parseFloat(this.user.farmer ? product.farmer_price : product.price);

                    let subscription = {
                        full_amount: amount.toFixed(2),
                        amount: amount.toFixed(2),
                        module: product.name,
                        user_id: this.user.userId,
                        product: this.product
                    };
                    let obj = _.findLast(this.user.subscriptionModules, {'module': product.id});

                    if (obj && typeof  obj !== "undefined") {
                        subscription.obj_id = obj.id;
                        subscription.id = product.id;
                        subscription.is_active = obj.is_active;
                        subscription.from_date = obj.from_date;
                        subscription.to_date = obj.to_date;
                        subscription.can_unsubscribe = obj.can_unsubscribe;
                        subscription.is_unsubscribed = obj.is_unsubscribed;
                        subscription.product = obj.product;
                    }
                    if (!subscription.from_date) {
                        subscription.from_date = moment().format('YYYY-MM-DD HH:mm:ss');
                    }
                    if (!subscription.to_date) {
                        subscription.to_date = moment(subscription.from_date).add(product.duration, 'months').format('YYYY-MM-DD HH:mm:ss');
                    }
                    form.subscription_modules.push(subscription);
                });
                return form;
            },

            toggleSubscription(row) {
                this.messageText = null;
                this.messageStatus = null;
                this.currentModuleId = row.obj_id;
                if (row.is_unsubscribed) {
                    this.confirmationMessage = lang.app.subscription.subscribe_confirmation_message;
                    this.confirmationType = 'subscribe';
                    this.isOpen = true;
                } else {
                    this.confirmationMessage = lang.app.subscription.unsubscribe_confirmation_message;
                    this.confirmationType = 'unsubscribe';
                    this.isOpen = true;
                }
            },

            confirmationResult(result) {
                this.isOpen = false;
                if (!result) {
                    return;
                }
                this.submitSubscriptionToggle(this.confirmationType === 'unsubscribe');
            },

            submitSubscriptionToggle(isUnsubscribed) {
                this.messageText = null;
                this.messageStatus = null;
                return api.subscription
                    .postUpdateIsUnsubscribeAction({'ids': [this.currentModuleId], 'is_unsubscribed': isUnsubscribed})
                    .then(response => {
                        this.form.subscription_modules.forEach((subscription) => {
                            if (subscription.obj_id === this.currentModuleId) {
                                subscription.is_unsubscribed = isUnsubscribed;
                            }
                        });
                        this.currentModuleId = null;
                        this.confirmationMessage = null;
                        this.confirmationType = null;
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.messageText = lang.validation.error_message;
                            this.messageStatus = "error";
                        }
                        this.currentModuleId = null;
                        this.confirmationMessage = null;
                        this.confirmationType = null;
                    })
            },

            getThemeColor() {
                const color = {
                    'capripedia': '#4a90e2',
                    'ovipedia': '#00a699',
                    'lactipedia': '#1b3869',
                    'farmnotes': '#9e0a0e'
                };
                return color[this.product];
            },
        },

        computed: {

            isUserProfileCompleted: function () {
                return this.user.is_profile_completed;
            },

            subscribedModules: function () {
                let modules = _.keyBy(this.user.subscriptionModules, 'module');
                return modules;
            },
        }

    }
</script>



// WEBPACK FOOTER //
// resources/js/components/subscription/CapripediaSubscriptionForm.vue